export default __webpack_public_path__ + "static/media/DerSchönstePinguin.8d4bbf04.png";